var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "mt-8 pb-12  sm:mt-12 sm:pb-16 lg:mt-16 lg:pb-24" },
      [
        _c("div", { staticClass: "relative" }, [
          _c(
            "div",
            {
              staticClass:
                "relative z-10 max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "max-w-md mx-auto lg:max-w-5xl lg:grid lg:grid-cols-3 lg:gap-5"
                },
                [
                  _c(
                    "div",
                    { staticClass: "rounded-lg shadow-lg overflow-hidden" },
                    [
                      _vm._m(1),
                      _c(
                        "div",
                        {
                          staticClass:
                            "px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6"
                        },
                        [
                          _c("ul", [
                            _c("li", { staticClass: "flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" 100 Manual WhatsApp messages. ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Whatsapp share button ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Whatsapp Chat button ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Reports ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Unlimited message templates ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Standard support ")]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "mt-6 rounded-md shadow" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  " block w-full text-center rounded-lg bg-white px-6 py-3 text-base leading-6 font-semibold font-display text-teal-600 hover:text-teal-500 focus:outline-none focus:shadow-outline transition ease-in-out duration-150",
                                attrs: {
                                  href: "#",
                                  "aria-describedby": "tier-standard"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.choosePlan("free")
                                  }
                                }
                              },
                              [
                                _vm.store.plan === "pro" ||
                                _vm.store.plan === "vip" ||
                                _vm.store.plan === "advanced"
                                  ? _c("span", [_vm._v("Contact us")])
                                  : _vm._e(),
                                _vm.store.plan === "free"
                                  ? _c("span", [_vm._v("Current Plan")])
                                  : _vm._e(),
                                _vm.store.plan === "limited_free"
                                  ? _c("span", [_vm._v("Current Plan")])
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "mt-4   lg:mt-0 relative z-10 rounded-lg shadow-xl"
                    },
                    [
                      _c("div", {
                        staticClass:
                          "pointer-events-none absolute inset-0 rounded-lg "
                      }),
                      _vm._m(2),
                      _c(
                        "div",
                        {
                          staticClass:
                            "px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6"
                        },
                        [
                          _c("ul", [
                            _c("li", { staticClass: "flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Free + ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Unlimited Manual Messages ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._m(3)
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Whatsapp CRM ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Email alerts ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Loox Integration ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Priority support ")]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "mt-6 rounded-md shadow" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out disabled:opacity-75",
                                attrs: {
                                  href: "#",
                                  "aria-describedby": "tier-enterprise",
                                  disabled: _vm.store.plan === "vip"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.choosePlan("vip")
                                  }
                                }
                              },
                              [
                                _vm.store.plan === "limited_free" ||
                                _vm.store.plan === "free"
                                  ? _c("span", [_vm._v("Start 14 day trial")])
                                  : _vm._e(),
                                _vm.store.plan === "advanced"
                                  ? _c("span", [_vm._v("Downgrade")])
                                  : _vm._e(),
                                _vm.store.plan === "vip"
                                  ? _c("span", [_vm._v("Current Plan")])
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "mt-4   lg:mt-0 relative z-10 rounded-lg shadow-xl"
                    },
                    [
                      _c("div", {
                        staticClass:
                          "pointer-events-none absolute inset-0 rounded-lg border-2 border-teal-400 "
                      }),
                      _vm._m(4),
                      _vm._m(5),
                      _c(
                        "div",
                        {
                          staticClass:
                            "px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6"
                        },
                        [
                          _c("ul", [
                            _c("li", { staticClass: "flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Free + ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Unlimited Manual Messages ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._m(6)
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Automation on own number ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Custom automated templates ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Whatsapp CRM ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Team inbox ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" 1000 Session messages included ")]
                              )
                            ]),
                            _c("li", { staticClass: "mt-4 flex items-start" }, [
                              _c("div", { staticClass: "flex-shrink-0" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-6 w-6 text-green-500",
                                    attrs: {
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "ml-3 text-base leading-6 text-gray-700"
                                },
                                [_vm._v(" Priority support ")]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "mt-6 rounded-md shadow" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out disabled:opacity-75",
                                attrs: {
                                  href: "#",
                                  "aria-describedby": "tier-enterprise",
                                  disabled: _vm.store.plan === "advanced"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.choosePlan("advanced")
                                  }
                                }
                              },
                              [
                                _vm.store.plan !== "advanced"
                                  ? _c("span", [_vm._v("Start 14 day trial")])
                                  : _c("span", [_vm._v("Current Plan")])
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]),
        _c(
          "div",
          {
            staticClass:
              "max-w-screen-xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8"
          },
          [
            _c("div", { staticClass: "Polaris-LegacyCard" }, [
              _vm._m(7),
              _c(
                "div",
                { staticClass: "Polaris-LegacyCard__Section" },
                _vm._l(_vm.faqs, function(faq, index) {
                  return _c("AccordianItem", {
                    key: index,
                    attrs: { title: faq.title, content: faq.content }
                  })
                }),
                1
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pt-12 sm:pt-16 lg:pt-24" }, [
      _c(
        "div",
        {
          staticClass:
            "max-w-screen-xl mx-auto text-center px-4 sm:px-6 lg:px-8"
        },
        [
          _c("div", { staticClass: "max-w-3xl mx-auto lg:max-w-none" }, [
            _c(
              "h2",
              {
                staticClass:
                  "text-lg leading-6 font-semibold text-gray-900 uppercase tracking-wider"
              },
              [_vm._v(" Pricing ")]
            ),
            _c(
              "p",
              {
                staticClass:
                  "mt-2 text-3xl leading-9 font-extrabold text-gray-700 sm:text-4xl sm:leading-10 lg:text-5xl lg:leading-none"
              },
              [_vm._v(" Affordable and simple pricing ")]
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "px-6 py-8 bg-white sm:p-10 sm:pb-6" }, [
      _c("div", [
        _c(
          "h3",
          {
            staticClass:
              "inline-flex px-4 py-1 rounded-full text-sm leading-5 font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600",
            attrs: { id: "tier-standard" }
          },
          [_vm._v(" Free ")]
        )
      ]),
      _c(
        "div",
        {
          staticClass:
            "mt-4 flex items-baseline text-6xl leading-none font-extrabold"
        },
        [
          _vm._v(" $0 "),
          _c(
            "span",
            {
              staticClass: "ml-1 text-2xl leading-8 font-medium text-gray-500"
            },
            [_vm._v(" /mo ")]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "px-6 py-8 bg-white sm:p-10 sm:pb-6 rounded-t-lg" },
      [
        _c("div", [
          _c(
            "h3",
            {
              staticClass:
                "inline-flex px-4 py-1 rounded-full text-sm leading-5 font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600",
              attrs: { id: "tier-enterprise" }
            },
            [_vm._v(" VIP ")]
          )
        ]),
        _c(
          "div",
          {
            staticClass:
              "mt-4 flex items-baseline text-6xl leading-none font-extrabold"
          },
          [
            _vm._v(" $9.99 "),
            _c(
              "span",
              {
                staticClass: "ml-1 text-2xl leading-8 font-medium text-gray-500"
              },
              [_vm._v(" /mo ")]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "ml-3 text-base leading-6 text-gray-700" }, [
      _vm._v(" Automated messages "),
      _c(
        "a",
        {
          staticClass: "text-blue-400 text-sm",
          attrs: {
            href:
              "https://docs.google.com/spreadsheets/d/1Bc8J7Majk2spWA7S8Lf6VV-0mGF11nYpKKedrv44hyc/edit?usp=sharing",
            target: "blank"
          }
        },
        [_vm._v("(Price per message)")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "absolute inset-x-0 top-0 transform translate-y-px" },
      [
        _c(
          "div",
          { staticClass: "flex justify-center transform -translate-y-1/2" },
          [
            _c(
              "span",
              {
                staticClass:
                  "inline-flex rounded-full bg-teal-400 px-4 py-1 text-sm leading-5 font-semibold tracking-wider uppercase text-white"
              },
              [_vm._v(" Recommended ")]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "px-6 py-8 bg-white sm:p-10 sm:pb-6 rounded-t-lg" },
      [
        _c("div", [
          _c(
            "h3",
            {
              staticClass:
                "inline-flex px-4 py-1 rounded-full text-sm leading-5 font-semibold tracking-wide uppercase bg-indigo-100 text-indigo-600",
              attrs: { id: "tier-enterprise" }
            },
            [_vm._v(" Advanced ")]
          )
        ]),
        _c(
          "div",
          {
            staticClass:
              "mt-4 flex items-baseline text-6xl leading-none font-extrabold"
          },
          [
            _vm._v(" $29 "),
            _c(
              "span",
              {
                staticClass: "ml-1 text-2xl leading-8 font-medium text-gray-500"
              },
              [_vm._v(" /mo ")]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "ml-3 text-base leading-6 text-gray-700" }, [
      _vm._v(" Automated messages "),
      _c(
        "a",
        {
          staticClass: "text-blue-400 text-sm",
          attrs: {
            href:
              "https://docs.google.com/spreadsheets/d/1Bc8J7Majk2spWA7S8Lf6VV-0mGF11nYpKKedrv44hyc/edit?usp=sharing",
            target: "blank"
          }
        },
        [_vm._v("(Price per message)")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Polaris-LegacyCard__Header" }, [
      _c("h2", { staticClass: "Polaris-Text--root Polaris-Text--headingLg" }, [
        _vm._v(" Frequently asked questions ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }